<template lang="pug">
    //- TODO: 下部に隙間が出来てるのでそれをなんとかできそうならなんとかしたい
    .box(:style="{height:height}")
        //- 普通の写真
        .img(v-if="!imgData.this_is_logo",:style="{width:width,transform:position(frameData.x,pos_y,index)}",:class="{odd:index%2!=0,even:index%2==0,'-active':scrollToggle,transition:transition}",@click="detailTrue")

            img.frame(:src="frame")
            .photo: img(:src="imgData.media_url")
        //- ロゴの表示される枠
        a.img(v-if="imgData.this_is_logo",href="https://renodeluxe.jp/",:style="{width:width,transform:position(frameData.x,pos_y,index)}",:class="{odd:index%2!=0,even:index%2==0,'-active':scrollToggle,transition:transition}")

            img.frame(:src="frame")
            .photo.link: img(src="@/assets/img/main-logo.svg")

</template>
<style lang="scss" scoped>
.box {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    transition: 3s;

    @media #{$pc} {
        width: 48%;
    }

    &.-active {
        justify-content: center !important;
        //position: absolute;
    }

    > .img {
        position: relative;
        height: 90%;
        right: 0%;

        &.transition {
            // 検索用：移動時間の設定
            transition: 1.5s;
        }

        &.even.-active,
        &.odd.-active {
            transform: translateX(0%) !important;
        }

        // &.even.-active {
        //     @media #{$pc} {
        //         transform: translateX(50%) !important;
        //         right: 50% !important;
        //     }
        // }

        // &.odd.-active {
        //     @media #{$pc} {
        //         transform: translateX(-50%) !important;
        //         right: -50% !important;
        //     }
        // }

        > .frame,
        > .photo {
            width: 90%;
            height: 100%;
        }

        > .frame {
            position: absolute;
            top: -1px;
            left: -1px;
        }

        > .photo {
            overflow: hidden;
            > img {
                object-fit: cover;
                width: 99%;
                height: 99%;
            }
        }

        > .photo.link {
            background: #fff;
            display: flex;
            justify-content: center;
            align-items: center;
            > img {
                object-fit: contain;
                width: 70%;
                height: 70%;
                transform: rotate(-7deg);
            }
        }
    }
}
</style>

<script>
import framejson from "@/assets/data/frame";
export default {
    name: "frameBox",
    props: {
        frameData: {
            type: Object,
            required: true
        },
        index: {
            type: Number,
            required: true
        },
        imgData: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            transition: false,
            skip: 0
        };
    },
    computed: {
        frame() {
            return require("@/assets/img/" + this.frameData.name);
        },
        aspect() {
            return this.frameData.width / this.frameData.height;
        },
        width() {
            if (this.$store.getters.getAspect === "width") {
                return (
                    this.$store.getters.getWidth *
                        this.frameData.widthRatio *
                        0.01 +
                    "px"
                );
            } else {
                return (
                    this.$store.getters.getHeight *
                        this.frameData.heightRatio *
                        this.aspect *
                        0.01 +
                    "px"
                );
            }
        },
        height() {
            if (this.$store.getters.getAspect === "height") {
                return (
                    this.$store.getters.getHeight *
                        this.frameData.heightRatio *
                        0.01 +
                    "px"
                );
            } else {
                return (
                    ((this.$store.getters.getWidth *
                        this.frameData.widthRatio) /
                        this.aspect) *
                        0.01 +
                    "px"
                );
            }
        },
        paddingHeight() {
            let heightTotal = 0;
            if (this.$store.getters.getAspect === "height") {
                for (let key of Object.keys(framejson.pc)) {
                    let h =
                        this.$store.getters.getHeight *
                        framejson["pc"][key]["heightRatio"];
                    heightTotal += h;
                    console.log(heightTotal);
                }
            } else {
                for (let key of Object.keys(framejson.pc)) {
                    let asp =
                        framejson["pc"][key]["width"] /
                        framejson["pc"][key]["height"];
                    let h =
                        (this.$store.getters.getWidth *
                            framejson["pc"][key]["widthRatio"]) /
                        asp;
                    heightTotal += h;
                    //console.log(heightTotal);
                }
            }

            heightTotal *= Math.floor(
                this.index / Object.keys(framejson["pc"]).length
            );
            //console.log(heightTotal);
            if (this.$store.getters.getWidth <= 980) {
                return 0;
            }
            return (heightTotal * 0.01) / 2 + "px";
        },
        pos_y() {
            if (this.$store.getters.getAspect === "height") {
                return this.frameData.y_h;
            } else {
                return this.frameData.y;
            }
        },
        scrollToggle() {
            return this.$store.getters.getScroll;
        },
        round() {
            return Math.floor(this.index / framejson["pc"].length);
        }
    },
    methods: {
        position(x, y, index) {
            if (this.$store.getters.getWidth <= 980) {
                return "translate(" + x + "%," + y + "%)";
            } else if (index % 2 === 0) {
                return "translate(" + -1 * x + "%," + y + "%)";
            } else {
                return "translate(" + x + "%," + y + "%)";
            }
        },
        flex(int) {
            if (this.$store.getters.getWidth <= 980) {
                return "center";
            } else if (int % 2 === 0) {
                return "flex-end";
            } else {
                return "flex-start";
            }
        },
        detailTrue() {
            this.$store.dispatch("setDetailTrue");
            this.$store.dispatch("setDetailImg", this.imgData);
            // console.log("true");
        },
        skiped() {
            this.skip++;
        }
    },
    watch: {
        scrollToggle() {
            if (!this.transition) {
                this.transition = true;
            }
        }
    }
};
</script>
